<section>
  <kendo-grid [data]="imageGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="false"
              [sort]="imageGridState.sort"
              (sortChange)="imageGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="imageGridState.take"
              [skip]="imageGridState.skip"
              [columnMenu]="false"
              (pageChange)="imageGridPageChange($event)"
              (dataStateChange)="imageDataStateChange($event)"
              [filter]="imageGridState.filter"
              [loading]="imageGridLoading">

    <kendo-grid-column field="languageCode" title="{{imageAdmin.languageCodeLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="componentName" title="{{imageAdmin.componentNameLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column field="imageType" title="{{imageAdmin.imageTypeLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="imageDescription" title="{{imageAdmin.imageDescriptionLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>





    <kendo-grid-column field="urlPath" title="{{imageAdmin.urlPathLbl}}">
      <ng-template kendoGridCellTemplate let-filter>

        <img src="{{imageURL}}{{filter.urlPath}}" style="height:200px;width:200px;" />

      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="displayOrder" title="{{imageAdmin.displayOrderLbl}}" [columnMenu]="false"
                       [filterable]="false" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column title="{{imageAdmin.isActiveLbl}}" [width]="135" field="isActive">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'"
                      [offLabel]="'No'"
                      [disabled]="true">
        </kendo-switch>
      </ng-template>
    </kendo-grid-command-column>



    <kendo-grid-command-column title="{{imageAdmin.actionLbl}}" [width]="155" field="">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                (click)="editImageForm(dataItem)">
          <span class=" k-icon k-i-edit k-i-pencil"></span>
        </button>
        <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem)">
          <span class="k-icon k-i-trash">
          </span>
        </button>

      </ng-template>
    </kendo-grid-command-column>


    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
  <div class="col-sm-12 center">
    <button (click)="toggleImageDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
      Add Home Page Banner
    </button>
  </div>
</section>
<section class="dialogSection">
  <kendo-dialog title=" Add Home Page Banner" *ngIf="imageDialog.opened" (close)="toggleImageDialog()">
    <form [formGroup]="imageForm" style="max-height: 450px">
      <div class="row">
        <input type="hidden" formControlName="imageId" />
        <div class="col-sm-12">

          <div class="form-group">
            <label class="lblCls">
              {{imageAdmin.languageCodeLbl}}<span class="requiredField">*</span>
            </label>
            <kendo-dropdownlist class="kendoInput" formControlName="language"
                                [ngModel]="{languageCode:selectedLanguageCode}"
                                [data]="languages"
                                textField="languageText" valueField="languageCode"
                                [ngClass]="{'borderRed':imageAdmin.isEmptyLanguage && imageAdmin.isSubmitted}"
                                (blur)="validateForm()">
            </kendo-dropdownlist>


          </div>

          <div class="form-group">
            <label class="lblCls">
              {{imageAdmin.componentNameLbl}}
            </label>
            <input type="text" kendoTextBox formControlName="componentName" class="kendoInput" readonly />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{imageAdmin.imageTypeLbl}}
            </label>
            <input type="text" kendoTextBox formControlName="imageType" class="kendoInput" readonly />
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{imageAdmin.imageDescriptionLbl}}<span class="requiredField">*</span>
            </label>
            <input type="text" kendoTextBox formControlName="imageDescription" class="kendoInput"
                   [ngClass]="{'borderRed':imageAdmin.isEmptyImageDescription && imageAdmin.isSubmitted}"
                   (blur)="validateForm()" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{imageAdmin.uploadLbl}}<span class="requiredField">*</span>
            </label>
            <!--<input type="file" formControlName="files" class="k-button btn kendoInput" name="fileupload"
    (change)="handleFileInput($event.target.files)" />-->
            <div [ngClass]="{borderRed : bannerImageUploadInvalid && imageAdmin.isSubmitted }" (blur)="validateForm()" class="kendoInput">
              <app-upload [multiple]="false" (fileSelect)="imageAdminSelected($event)" [uploadFolderPath]="'TempDocs'"
                          (uploadSuccess)="imageAdminUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>
            </div>
          </div>
          <div class="form-group">
            <img [src]="imageSrc" *ngIf="imageSrc" style="height: 150px; width:465px">
            <label class="lblCls">
              {{filePath}}
            </label>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{imageAdmin.displayOrderLbl}}<span class="requiredField">*</span>
            </label>
            <input type="number" kendoTextBox formControlName="displayOrder" class="kendoInput"
                   [ngClass]="{'borderRed':imageAdmin.isEmptyImageDisplayOrder && imageAdmin.isSubmitted}"
                   (blur)="validateForm()" />
          </div>
          <div class="form-group">
            imageURL
            <label class="lblCls">
              {{imageAdmin.isActiveLbl}}
            </label>
            <kendo-switch formControlName="isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                          class="activeSwitchCls">
            </kendo-switch>
          </div>
        </div>

      </div>

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="toggleImageDialog()">
                Close
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="saveImageForm()">
                Save<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>
<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.imageDescription }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
